<div class="modal-header" style="padding: 0.5rem; border: none;">
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()" style="font-size: 2rem;">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
<div class="modal-body" style="padding-bottom: 5px;padding-top: 0">
  <ebs-offline-mode></ebs-offline-mode>
</div>